var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIllustrationHomeHab(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 351,
    height: 350,
    viewBox: "0 0 351 350",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.16895 182.436V15.9929C1.16895 7.62913 7.95633 0.851562 16.3322 0.851562H334.665C343.041 0.851562 349.828 7.62913 349.828 15.9929V37.9973",
    stroke: "#6F7C87",
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M311.645 272.137L238.417 41.5234H79.51L155.187 279.855C159.45 293.287 149.411 306.986 135.301 306.986H286.094C304.221 306.986 317.122 289.388 311.639 272.137H311.645Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M155.187 279.855L79.51 41.5234H67.8714L80.2267 80.4317L93.5073 122.251L143.779 280.57C145.587 286.269 141.329 292.08 135.339 292.08H120.534C116.677 292.08 113.26 289.586 112.094 285.911L60.1266 122.251H48.4399L101.172 288.314C104.702 299.434 115.035 306.986 126.717 306.986H135.301C149.411 306.986 159.456 293.287 155.187 279.855Z",
    fill: "#A3C5EB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M120.528 292.079H135.333C141.324 292.079 145.581 286.268 143.773 280.57L93.502 122.25H60.1213L112.088 285.91C113.254 289.585 116.667 292.079 120.528 292.079Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M67.8713 41.5234L80.2266 80.4317L67.8713 41.5234Z",
    fill: "#6F7C87"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M241.289 50.5709L238.417 41.5234H67.8715L143.773 280.565C145.581 286.264 141.324 292.074 135.333 292.074H120.528C116.672 292.074 113.254 289.58 112.088 285.906L60.1213 122.245",
    stroke: "#6F7C87",
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M93.4109 263.879L101.172 288.314C104.702 299.433 115.035 306.985 126.717 306.985H286.094C304.221 306.985 317.122 289.387 311.639 272.136L263.213 119.633",
    stroke: "#6F7C87",
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M93.5019 122.242H48.4399L74.1186 203.119",
    stroke: "#6F7C87",
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M79.51 41.5234L155.187 279.855C159.45 293.287 149.411 306.986 135.301 306.986",
    stroke: "#6F7C87",
    strokeMiterlimit: 10
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M104.418 68.8828H222.082",
    stroke: "#F39200",
    strokeMiterlimit: 10
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M126.663 138.938H244.327",
    stroke: "#F39200",
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M130.429 150.789H252.634",
    stroke: "#F39200",
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M108.088 80.4297H233.662",
    stroke: "#F39200",
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M123.123 127.781H248.697",
    stroke: "#F39200",
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M134.226 162.75H213.075",
    stroke: "#F39200",
    strokeMiterlimit: 10
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M158.894 240.445H276.558",
    stroke: "#F39200",
    strokeMiterlimit: 10
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M162.659 252.289H284.864",
    stroke: "#F39200",
    strokeMiterlimit: 10
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M166.457 264.25H245.306",
    stroke: "#F39200",
    strokeMiterlimit: 10
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M119.683 116.945H225.088",
    stroke: "#F39200",
    strokeMiterlimit: 10
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M111.543 91.3125H202.613",
    stroke: "#F39200",
    strokeMiterlimit: 10
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M142.837 189.875H248.697",
    stroke: "#F39200",
    strokeMiterlimit: 10
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M146.507 201.422H272.081",
    stroke: "#F39200",
    strokeMiterlimit: 10
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M149.962 212.312H266.449",
    stroke: "#F39200",
    strokeMiterlimit: 10
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M79.8577 142.609H99.9684",
    stroke: "#6F7C87",
    strokeMiterlimit: 10
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M83.6606 154.57H103.766",
    stroke: "#6F7C87",
    strokeMiterlimit: 10
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M108.328 232.266H128.439",
    stroke: "#6F7C87",
    strokeMiterlimit: 10
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M112.088 244.109H132.199",
    stroke: "#6F7C87",
    strokeMiterlimit: 10
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M115.891 256.078H135.997",
    stroke: "#6F7C87",
    strokeMiterlimit: 10
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M92.2717 181.703H112.382",
    stroke: "#6F7C87",
    strokeMiterlimit: 10
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M95.9409 193.25H116.046",
    stroke: "#6F7C87",
    strokeMiterlimit: 10
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M99.396 204.133H119.507",
    stroke: "#6F7C87",
    strokeMiterlimit: 10
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M74.1186 203.124C77.2689 213.047 69.8504 223.163 59.4313 223.163H16.5783C8.06865 223.163 1.16895 230.053 1.16895 238.55V333.869C1.16895 342.233 7.95633 349.01 16.3322 349.01H334.665C343.041 349.01 349.828 342.233 349.828 333.869V94.1116C349.828 85.6142 342.929 78.7245 334.419 78.7245L261.512 78.7405C254.794 78.7405 248.852 74.3984 246.82 68.0054L241.284 50.5781",
    stroke: "#6F7C87",
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllustrationHomeHab);
export default __webpack_public_path__ + "static/media/illustration-home-hab.4a8fb7ae.svg";
export { ForwardRef as ReactComponent };